<template>
  <div>
    <div v-if="userid === -1 || course_info === null">
      <loading-page/>
    </div>
    <div v-if="userid !== -1 && course_info !== null">
      <van-sticky offset-top="0">
      <div style="text-align: center;font-weight: bold;font-size: 20px; background-color: white;
      height:30px;padding: 20px 0;border-bottom: 1px solid rgba(145, 145, 145, 0.55);">
        学员姓名：{{ course_info.name }}
      </div>
      </van-sticky>
<!--      <van-divider></van-divider>-->
      <div class="studentinfo">
        <h3 style="margin: 5px 0;text-align: center;">参加期次</h3>
        <div
            style="display: flex;flex-flow: column wrap;align-content: flex-start;align-items: flex-start;justify-content: space-evenly;">
          <div v-for="term in course_info.terms" :key="term.id">
            {{ term.name }}
          </div>
        </div>
        <van-divider style="background-color: #b0b0b0;"></van-divider>
        <h3 style="margin: 5px 0;text-align: center">基本信息</h3>
        <div
            style="display: flex;flex-flow: column wrap;align-content: flex-start;align-items: flex-start;justify-content: space-evenly;">
          <div></div>
          <div>
            <b>性别：</b>
            <span v-if="course_info.gender === 'M'">男</span>
            <span v-if="course_info.gender === 'F'">女</span>
          </div>
          <div><b>电话：</b> {{ course_info.phone }}</div>
          <div><b>IM：</b> {{ course_info.im }}</div>
          <div><b>单位：</b> {{ course_info.company }}</div>
        </div>
      </div>
      <div
          style="padding-left: 20px;"
          v-if="course_info.note !== null && course_info.note !== ''"
      >
        <van-divider style="background-color: #b0b0b0;"></van-divider>
        <div>学员留言</div>
        <div>{{ course_info.note }}</div>
      </div>
      <div class="studentinfo" style="background-color: #d5e4fc"
          v-if="course_info.admin_note !== null && course_info.admin_note !== ''"
      >
<!--        <van-divider style="background-color: #b0b0b0;"></van-divider>-->
        <h3 style="margin: 5px 0">管理员备注：</h3>
        <div style="margin: 0 5px;">{{ course_info.admin_note }}</div>
      </div>
<!--      <van-divider></van-divider>-->
      <div style="text-align: center; margin: 30px auto;" @click="viewPriceDetails()">
        <van-button type="primary" @click="modify_earnest">点此查看应缴费用计算详情
        </van-button>
      </div>
      <van-divider style="background-color: #b0b0b0;margin:20px 10px;"></van-divider>
      <div style="display: flex;flex-flow: column wrap;place-content: space-around space-evenly;align-items: center;align-content: center;"
           v-if="course_info.receipts.length > 0">
        <div><b>收款项：</b></div>
        <div v-for="receipt in course_info.receipts" :key="receipt.id">
          <van-icon name="gold-coin" style="color: cornflowerblue"/>
          {{ receipt.receiver }}: {{ receipt.name }} {{ receipt.total }}元
        </div>
      </div>
<!--      <van-divider style="margin:20px 10px;"></van-divider>-->
      <van-row style="display: flex;align-items: center">
        <van-col span="12">
          <div style="text-align: center">
            <van-circle
                :currentRate="currentRate"
                :rate="70"
                :speed="100"
                :color="gradientColor"
                :text="text"
                :stroke-width="80"
            ></van-circle>
            <div>付款进度</div>
            <div><span style="color: #07c160">{{ course_info.paid }}</span>/{{ course_info.price.payable }}</div>
          </div>
        </van-col>
        <van-col span="12">
          <div style="font-weight: bold;">课程原价： {{ course_info.original }}元</div>
          <div style="color: #ff0000">学员应缴： {{ course_info.price.payable }}元</div>
          <div v-if="course_info.invoice" style="color: #1890ff">
            开票税点： {{ course_info.tax }}元
          </div>
          <div v-if="course_info.residue > 0" style="color: red">
            剩余应缴： {{ course_info.residue }}元
          </div>
          <div>
            已缴定金：
            <span
                v-if="course_info.earnest_status === 'PD'"
                style="color: #07c160"
            >
              {{ course_info.earnest }}元
            </span>
            <span
                v-if="course_info.earnest_status !== 'PD'"
                style="color: #7f7f7f"
            >
              未支付
            </span>
          </div>
          <div>
            已缴尾款：
            <span
                v-if="course_info.final_status === 'PD'"
                style="color: #07c160"
            >
              {{ course_info.final }}元
            </span>
            <span
                v-if="course_info.final_status !== 'PD'"
                style="color: #7f7f7f"
            >
              未支付
            </span>
          </div>
        </van-col>
      </van-row>
      <div>
        <van-divider style="background-color: #b0b0b0;margin:20px 10px;"></van-divider>
        <!--调整定金&添加收款-->
        <van-row>
          <van-col span="12">
            <div style="text-align: center; margin-top: 20px">
              <van-button type="primary" @click="modify_earnest"
                          icon="gold-coin-o"
              >调整定金
              </van-button>
            </div>
          </van-col>
          <van-col span="12">
            <div style="text-align: center; margin-top: 20px">
              <van-button type="primary" @click="to_add_receipt"
                          icon="plus"
              >添加收款
              </van-button>
            </div>
          </van-col>
        </van-row>
      </div>
      <h3 style="margin: 30px auto;text-align: center">调整金额操作说明：</h3>
      <ol style="text-align: left;margin:0 20px;line-height: 1.5;">
        <li>1. 往期已经支付了定金或全款并且<b style="color:#fe0909;">已经结算</b>的学员，请点击下方 ⌜调整定金⌟ 调整；<br>（例如之前已经支付定金500元，就填写-500）</li>
        <li>2. 往期已经支付了定金或全款但是<b style="color:#fe0909;">未结算</b>的学员，请点击下方 ⌜添加收款⌟ 调整。<br>（例如之前已经支付定金产品课程500，就选择收款人为Jessesn往期收款，报名多门课程，请将收款人和对应金额拆开添加）</li>
        <li>3. 本期通过其他方式支付定金或全款的学员，请点击下方 ⌜添加收款⌟ 调整。</li>
      </ol>
      <van-divider style="background-color: #b0b0b0;margin:20px 10px;"></van-divider>
      <div style="text-align: center; margin-top: 20px">
        <van-button type="default" @click="to_summary">返回统计页面</van-button>
      </div>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <MainTabBar></MainTabBar>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from "vuex";
import LoadingPage from "../../components/LoadingPage";
import {Divider} from "vant";
import {Row, Col} from "vant";
import {Circle} from "vant";
import {Button} from "vant";
import {Icon} from "vant";
import MainTabBar from "@/components/MainTabBar";
import {Sticky} from "vant";


export default {
  name: "courseInfo",
  components: {
    "van-button": Button,
    "van-icon": Icon,
    "van-divider": Divider,
    "van-circle": Circle,
    "van-row": Row,
    "van-col": Col,
    "van-sticky": Sticky,
    "loading-page": LoadingPage,
    MainTabBar
  },
  data() {
    return {
      course_info_id: 0,
      gradientColor: {
        "0%": "#3fecff",
        "100%": "#6149f6"
      }
    };
  },
  computed: {
    ...mapState({
      token: state => state.users.token,
      userid: state => state.users.userid,
      course_info: state => state.admin.course_info.course_info
    }),
    currentRate() {
      if (this.course_info.residue === 0) {
        return 100;
      }
      return (this.course_info.paid / this.course_info.price.payable) * 100;
    },
    text() {
      return this.currentRate.toFixed(0) + "%";
    }
  },
  methods: {
    ...mapActions("admin/course_info", ["toGetCourseInfo"]),
    ...mapMutations("admin/course_info", ["initCourseInfo"]),
    ...mapActions({tokenChecker: "users_tokenChecker"}),
    viewPriceDetails() {
      let path = `/priceDetails/${this.course_info_id}`;
      this.$router.push({path: path});
    },
    to_add_receipt() {
      this.$router.push({path: `/add_receipt/${this.course_info_id}/`});
    },
    modify_earnest() {
      this.$router.push({path: `/earnest_adjust/${this.course_info_id}/`});
    },
    to_summary() {
      this.$router.push({name: "admin_summary"});
    }
  },
  beforeMount() {
    this.course_info_id = this.$route.params.id;
    // 应该在每个登录才能操作的视图加上下面这句
    this.tokenChecker();
    this.initCourseInfo();
    if (this.userid !== -1 && this.course_info === null) {
      this.toGetCourseInfo(this.course_info_id);
    }
    this.$store.state.system.tabBarActive = "user";
  },
  updated() {
    this.course_info_id = this.$route.params.id;
    if (
        this.userid !== -1 &&
        this.course_info === null &&
        this.course_info_id !== 0
    ) {
      this.toGetCourseInfo(this.course_info_id);
    }
  }
};
</script>

<style scoped>
.studentinfo {
  background-color: #EDF1FF;
  display: flex;
  flex-flow: column wrap;
  align-content: space-around;
  margin: 20px;
  padding: 20px;
  /*box-shadow: #b5b5b5 0px 1px 2px;*/
  border-radius: 10px;
}
</style>
